function getRowIndex(el) {
  var row = el.closest('.compare-lightbox--row');
  if (!row) return -1;
  var table = el.closest('.compare-lightbox--table');
  if (!table) return -1;
  var rows = table.querySelectorAll('.compare-lightbox--row');
  return Array.prototype.indexOf.call(rows, row);
}

function getAllSiblings(el, selector) {
  var rowIndex = getRowIndex(el);
  if (rowIndex < 0) return [el];
  var all = [];
  document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
    var rows = table.querySelectorAll('.compare-lightbox--row');
    if (rows[rowIndex]) {
      var match = rows[rowIndex].querySelector(selector);
      if (match) all.push(match);
    }
  });
  return all.length ? all : [el];
}

function clearRowHeight(rowIndex) {
  if (rowIndex < 0) return;
  document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
    var rows = table.querySelectorAll('.compare-lightbox--row');
    if (rows[rowIndex]) rows[rowIndex].style.height = '';
  });
}

function restoreRowHeight(rowIndex) {
  if (rowIndex < 0) return;
  return setTimeout(function () {
    var maxHeight = 0;
    document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
      var rows = table.querySelectorAll('.compare-lightbox--row');
      if (rows[rowIndex]) maxHeight = Math.max(maxHeight, rows[rowIndex].scrollHeight);
    });
    document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
      var rows = table.querySelectorAll('.compare-lightbox--row');
      if (rows[rowIndex]) rows[rowIndex].style.height = maxHeight + 'px';
    });
  }, 350);
}

function getAllFwContainers(rowIndex) {
  if (rowIndex < 0) return [];
  var all = [];
  document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
    var rows = table.querySelectorAll('.compare-lightbox--row');
    if (rows[rowIndex]) {
      var container = rows[rowIndex].querySelector('.fw-enhancements');
      if (container) all.push(container);
    }
  });
  return all;
}

function setFwRowHeight(rowIndex) {
  if (rowIndex < 0) return;
  var rows = [];
  document.querySelectorAll('.compare-lightbox--table').forEach(function (table) {
    var tableRows = table.querySelectorAll('.compare-lightbox--row');
    if (tableRows[rowIndex]) rows.push(tableRows[rowIndex]);
  });
  rows.forEach(function (r) { r.style.height = ''; });
  setTimeout(function () {
    var maxHeight = 0;
    rows.forEach(function (r) { maxHeight = Math.max(maxHeight, r.scrollHeight); });
    rows.forEach(function (r) { r.style.height = maxHeight + 'px'; });
  }, 460);
}

function initCompareTray(root) {
  root = root || document;
  root.querySelectorAll('.compare-tray-options--expandable').forEach(function (el) {
    if (el.dataset.compareTrayInit) return;
    el.dataset.compareTrayInit = '1';
    var locked = false;
    var rowIndex = -1;
    var restoreTimer = null;

    el.addEventListener('mouseenter', function () {
      rowIndex = getRowIndex(el);
      if (restoreTimer) { clearTimeout(restoreTimer); restoreTimer = null; }
      if (!locked) {
        var siblings = getAllSiblings(el, '.compare-tray-options--expandable');
        clearRowHeight(rowIndex);
        siblings.forEach(function (e) {
          e.classList.add('compare-tray-options--expanded');
          e.classList.add('compare-tray-options--hovered');
        });
      }
    });

    el.addEventListener('mouseleave', function () {
      if (locked) return;
      var siblings = getAllSiblings(el, '.compare-tray-options--expandable');
      siblings.forEach(function (e) {
        if (!e.classList.contains('compare-tray-options--locked')) {
          e.classList.remove('compare-tray-options--expanded');
          e.classList.remove('compare-tray-options--hovered');
        }
      });
      restoreTimer = restoreRowHeight(rowIndex);
    });

    el.addEventListener('click', function () {
      locked = !locked;
      rowIndex = getRowIndex(el);
      if (restoreTimer) { clearTimeout(restoreTimer); restoreTimer = null; }
      var siblings = getAllSiblings(el, '.compare-tray-options--expandable');
      if (locked) {
        clearRowHeight(rowIndex);
        siblings.forEach(function (e) {
          e.classList.add('compare-tray-options--expanded');
          e.classList.add('compare-tray-options--locked');
        });
      } else {
        siblings.forEach(function (e) {
          e.classList.remove('compare-tray-options--locked');
          e.classList.remove('compare-tray-options--expanded');
          e.classList.remove('compare-tray-options--hovered');
        });
        restoreTimer = restoreRowHeight(rowIndex);
      }
    });
  });
}

function initFirmwareCards(root) {
  root = root || document;
  root.querySelectorAll('.fw-card:not(.fw-card--disabled):not(.fw-card--tray):not(.fw-card--tray-expandable)').forEach(function (card) {
    if (card.dataset.fwInit) return;
    card.dataset.fwInit = '1';

    var closeBtn = card.querySelector('.fw-card__close');
    var cardType = card.dataset.fwCard;

    card.addEventListener('click', function (e) {
      if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
      if (card.classList.contains('fw-card--expanded')) return;

      var rowIndex = getRowIndex(card);
      var allContainers = getAllFwContainers(rowIndex);

      allContainers.forEach(function (container) {
        var cardsWrapper = container.querySelector('.fw-enhancements__cards');
        container.querySelectorAll('.fw-card--expanded').forEach(function (c) {
          c.classList.remove('fw-card--expanded');
        });
        var selector = '.fw-card[data-fw-card=' + cardType + ']:not(.fw-card--disabled)';
        var target = container.querySelector(selector);
        if (!target) target = container.querySelector('.fw-card:not(.fw-card--disabled)');
        if (target) {
          target.classList.add('fw-card--expanded');
          cardsWrapper.classList.add('has-expanded');
        }
      });

      setFwRowHeight(rowIndex);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var rowIndex = getRowIndex(card);
        var allContainers = getAllFwContainers(rowIndex);
        allContainers.forEach(function (container) {
          var cardsWrapper = container.querySelector('.fw-enhancements__cards');
          container.querySelectorAll('.fw-card--expanded').forEach(function (c) {
            c.classList.remove('fw-card--expanded');
          });
          cardsWrapper.classList.remove('has-expanded');
        });
        clearRowHeight(rowIndex);
      });
    }
  });
}

function initTrayCards(root) {
  root = root || document;
  root.querySelectorAll('.fw-card--tray-expandable').forEach(function (card) {
    if (card.dataset.fwTrayInit) return;
    card.dataset.fwTrayInit = '1';

    var closeBtn = card.querySelector('.fw-card__close');

    card.addEventListener('click', function (e) {
      if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
      if (card.classList.contains('fw-card--expanded')) return;

      var rowIndex = getRowIndex(card);
      var allContainers = getAllFwContainers(rowIndex);

      allContainers.forEach(function (container) {
        var cardsWrapper = container.querySelector('.fw-enhancements__cards');
        container.querySelectorAll('.fw-card--expanded').forEach(function (c) {
          c.classList.remove('fw-card--expanded');
        });
        var target = container.querySelector('.fw-card--tray-expandable');
        if (target) {
          target.classList.add('fw-card--expanded');
          cardsWrapper.classList.add('has-expanded');
        }
      });

      setFwRowHeight(rowIndex);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var rowIndex = getRowIndex(card);
        var allContainers = getAllFwContainers(rowIndex);
        allContainers.forEach(function (container) {
          var cardsWrapper = container.querySelector('.fw-enhancements__cards');
          container.querySelectorAll('.fw-card--expanded').forEach(function (c) {
            c.classList.remove('fw-card--expanded');
          });
          cardsWrapper.classList.remove('has-expanded');
        });
        clearRowHeight(rowIndex);
      });
    }
  });
}

function equalizeSuitListHeights() {
  equalizeSuitSection('best_for');
  equalizeSuitSection('not_best_for');
}

function equalizeSuitSection(section, openIndex) {
  var allLists = document.querySelectorAll('.suit-list[data-suit-section="' + section + '"]');
  if (allLists.length < 2) return;

  var maxItems = 0;
  allLists.forEach(function (list) {
    var count = list.querySelectorAll('.suit-item').length;
    if (count > maxItems) maxItems = count;
  });

  for (var i = 0; i < maxItems; i++) {
    var maxH = 0;
    var itemsAtPos = [];
    var skipReset = (openIndex !== undefined && i === openIndex);

    allLists.forEach(function (list) {
      var items = list.querySelectorAll('.suit-item');
      if (items[i]) {
        if (!skipReset) items[i].style.minHeight = '';
        var h = items[i].getBoundingClientRect().height;
        if (h > maxH) maxH = h;
        itemsAtPos.push(items[i]);
      }
    });

    if (maxH > 0) {
      itemsAtPos.forEach(function (item) {
        item.style.minHeight = maxH + 'px';
      });
    }
  }

  var rows = [];
  allLists.forEach(function (list) {
    var row = list.closest('.compare-lightbox--row');
    if (row && rows.indexOf(row) === -1) rows.push(row);
  });
  rows.forEach(function (r) { r.style.height = ''; });
  var maxRowH = 0;
  rows.forEach(function (r) { maxRowH = Math.max(maxRowH, r.scrollHeight); });
  rows.forEach(function (r) { r.style.height = maxRowH + 'px'; });
}

function getSuitItemIndex(item, section) {
  var allItems = document.querySelectorAll(
    '.suit-item--expandable[data-suit-section="' + section + '"]'
  );
  var productIds = [];
  allItems.forEach(function (el) {
    var pid = el.dataset.productId;
    if (productIds.indexOf(pid) === -1) productIds.push(pid);
  });
  if (productIds.length === 0) return -1;

  var itemPid = item.dataset.productId;
  var sameProductItems = document.querySelectorAll(
    '.suit-item--expandable[data-suit-section="' + section + '"][data-product-id="' + itemPid + '"]'
  );
  return Array.prototype.indexOf.call(sameProductItems, item);
}

function openSuitPosition(section, index) {
  window._suitOpenPos[section] = index;

  var allItems = document.querySelectorAll(
    '.suit-item--expandable[data-suit-section="' + section + '"]'
  );
  var productIds = [];
  allItems.forEach(function (el) {
    var pid = el.dataset.productId;
    if (productIds.indexOf(pid) === -1) productIds.push(pid);
  });

  productIds.forEach(function (pid) {
    var productItems = Array.prototype.slice.call(document.querySelectorAll(
      '.suit-item--expandable[data-suit-section="' + section + '"][data-product-id="' + pid + '"]'
    ));
    productItems.forEach(function (item, i) {
      var btn = item.querySelector('.suit-item__btn');
      var descId = btn ? btn.getAttribute('aria-controls') : null;
      var desc = descId ? document.getElementById(descId) : null;
      if (i === index) {
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (desc) desc.hidden = false;
      } else {
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (desc) desc.hidden = true;
      }
    });
  });

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      equalizeSuitSection(section, index);
      equalizeSuitRowHeight(section);
    });
  });
}

function closeSuitSection(section) {
  window._suitOpenPos[section] = -1;

  document.querySelectorAll(
    '.suit-item--expandable[data-suit-section="' + section + '"]'
  ).forEach(function (item) {
    var btn = item.querySelector('.suit-item__btn');
    var descId = btn ? btn.getAttribute('aria-controls') : null;
    var desc = descId ? document.getElementById(descId) : null;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (desc) desc.hidden = true;
  });

  clearSuitRowHeight(section);
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      equalizeSuitSection(section);
    });
  });
}

function equalizeSuitRowHeight(section) {
  var allLists = document.querySelectorAll('.suit-list[data-suit-section="' + section + '"]');
  if (allLists.length === 0) return;
  var rows = [];
  allLists.forEach(function (list) {
    var row = list.closest('.compare-lightbox--row');
    if (row && rows.indexOf(row) === -1) rows.push(row);
  });
  rows.forEach(function (r) { r.style.height = ''; });
  setTimeout(function () {
    var maxH = 0;
    rows.forEach(function (r) { maxH = Math.max(maxH, r.scrollHeight); });
    rows.forEach(function (r) { r.style.height = maxH + 'px'; });
  }, 20);
}

function clearSuitRowHeight(section) {
  var allLists = document.querySelectorAll('.suit-list[data-suit-section="' + section + '"]');
  allLists.forEach(function (list) {
    var row = list.closest('.compare-lightbox--row');
    if (row) row.style.height = '';
  });
}

function initSuitabilityItems(root) {
  root = root || document;
  if (!window._suitOpenPos) {
    window._suitOpenPos = { best_for: -1, not_best_for: -1 };
  }

  root.querySelectorAll('.suit-item--expandable[data-suit-item]').forEach(function (item) {
    if (item.dataset.suitInit) return;
    item.dataset.suitInit = '1';

    var btn = item.querySelector('.suit-item__btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var section = item.dataset.suitSection;
      var clickedIndex = getSuitItemIndex(item, section);
      var currentOpen = window._suitOpenPos[section];
      if (currentOpen === clickedIndex) {
        closeSuitSection(section);
      } else {
        openSuitPosition(section, clickedIndex);
      }
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
      if (e.key === 'Escape') {
        closeSuitSection(item.dataset.suitSection);
      }
    });
  });
}

// =====================
// COMPARE BANNER
// =====================
function initCompareBanner() {
  var panel = document.querySelector('product-compare-panel');
  if (!panel) return;

  var slotsContainer = document.getElementById('CompareBannerSlots');
  var btn = document.getElementById('CompareBannerBtn');
  var btnText = btn ? btn.querySelector('.compare-banner__btn-text') : null;

  if (!slotsContainer || !btn) return;

  var STORAGE_KEY = 'compare-products-vision';
  var cached = window._compareBannerCache = window._compareBannerCache || {};
  var bannerEl = document.getElementById('CompareBanner');

  // Clean up any stale toggle state from previous sessions
  localStorage.removeItem('compare-toggle-state');

  // Watch body class for compare-true toggle (controlled by facets.js FacetToolbar)
  var bodyObserver = new MutationObserver(function () {
    var isOn = document.body.classList.contains('compare-true');
    if (bannerEl) bannerEl.style.display = isOn ? '' : 'none';
    if (!isOn) {
      localStorage.removeItem(STORAGE_KEY);
      renderBanner();
      document.querySelectorAll('.product-card-compare--checkbox').forEach(function (cb) {
        cb.checked = false;
      });
    }
  });
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  function getStoredProducts() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveProducts(products) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  }

  function removeProduct(productId) {
    var products = getStoredProducts().filter(function (p) {
      return String(p.id) !== String(productId);
    });
    saveProducts(products);
    var checkbox = document.querySelector(
      '.product-card-compare--checkbox[data-product-id="' + productId + '"]'
    );
    if (checkbox && checkbox.checked) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderBanner();
  }

  function fixImageUrl(url) {
    if (!url) return null;
    return url.replace(/\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i, '_200x200.$1$2');
  }

  function fetchProductImage(product, slot, index) {
    fetch(product.url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var src = fixImageUrl(data.featured_image);
        cached[product.id] = src || '';
        if (slot.dataset.productId === String(product.id)) {
          renderSlot(slot, index, product, src);
        }
      })
      .catch(function () {
        cached[product.id] = '';
      });
  }

  function renderSlot(slot, index, product, imgSrc) {
    slot.innerHTML =
      '<div class="compare-banner__slot-inner">' +
        '<span class="compare-banner__slot-num">' + (index + 1) + '</span>' +
        (imgSrc
          ? '<img src="' + imgSrc + '" alt="" class="compare-banner__slot-img">'
          : '<div class="compare-banner__slot-placeholder"></div>') +
        '<button class="compare-banner__slot-remove" aria-label="Remove product" data-product-id="' + product.id + '">' +
          '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" width="10" height="10">' +
            '<path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
      '</div>';
  }

  function renderBanner() {
    var products = getStoredProducts();
    var count = products.length;
    var slots = slotsContainer.querySelectorAll('.compare-banner__slot');

    slots.forEach(function (slot, i) {
      var product = products[i];
      if (product) {
        slot.classList.add('compare-banner__slot--filled');
        slot.classList.remove('compare-banner__slot--empty');
        if (slot.dataset.productId !== String(product.id)) {
          slot.dataset.productId = String(product.id);
          if (cached[product.id] !== undefined) {
            renderSlot(slot, i, product, cached[product.id] || null);
          } else {
            renderSlot(slot, i, product, null);
            fetchProductImage(product, slot, i);
          }
        }
      } else {
        slot.classList.remove('compare-banner__slot--filled');
        slot.classList.add('compare-banner__slot--empty');
        slot.dataset.productId = '';
        slot.innerHTML = '<div class="compare-banner__slot-placeholder"></div>';
      }
    });

    if (count >= 2) {
      btn.disabled = false;
      btn.classList.remove('compare-banner__btn--disabled');
      btn.classList.add('compare-banner__btn--active');
      btnText.textContent = 'Compare ' + count + ' selected product' + (count !== 1 ? 's' : '');
    } else {
      btn.disabled = true;
      btn.classList.add('compare-banner__btn--disabled');
      btn.classList.remove('compare-banner__btn--active');
      btnText.textContent = count === 1 ? 'Select more products to compare' : 'Select products to compare';
    }
  }

  slotsContainer.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.compare-banner__slot-remove');
    if (!removeBtn) return;
    removeProduct(removeBtn.dataset.productId);
  });

  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    var modal = document.getElementById('CompareModal');
    var table = document.querySelector('product-compare-table');
    if (modal && table) {
      modal.show();
      table.dispatchEvent(new CustomEvent('render-product-compare-modal', { bubbles: true }));
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) renderBanner();
  });

  // Poll localStorage for same-tab checkbox changes
  var lastSnapshot = JSON.stringify(getStoredProducts());
  setInterval(function () {
    var current = JSON.stringify(getStoredProducts());
    if (current !== lastSnapshot) {
      lastSnapshot = current;
      renderBanner();
    }
  }, 150);

  // Pre-warm image cache
  function prewarmImageCache() {
    document.querySelectorAll('.product-card-compare--checkbox').forEach(function (cb) {
      var productId = cb.dataset.productId;
      var productUrl = cb.dataset.productUrl;
      if (!productId || !productUrl || cached[productId] !== undefined) return;
      fetch(productUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          cached[productId] = fixImageUrl(data.featured_image) || '';
        })
        .catch(function () {
          cached[productId] = '';
        });
    });
  }

  setTimeout(prewarmImageCache, 1000);
  renderBanner();
}

function patchComparePanelForBanner() {
  document.querySelectorAll('.compare-drawer, .compare-toggle').forEach(function (el) {
    el.style.display = 'none';
  });
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeSuitSection('best_for');
    closeSuitSection('not_best_for');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  initCompareTray(document);
  initFirmwareCards(document);
  initTrayCards(document);
  initSuitabilityItems(document);
  initCompareBanner();
  patchComparePanelForBanner();
  setTimeout(equalizeSuitListHeights, 100);
});

var compareTrayObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) {
        initCompareTray(node);
        initFirmwareCards(node);
        initTrayCards(node);
        initSuitabilityItems(node);
      }
    });
  });
});

compareTrayObserver.observe(document.body, { childList: true, subtree: true });